import './ModalComponent.scss';

function ModalComponent(props) {
  const closeMessage = () => {
    props.setShowModal(false);
  };

  return (
    <div className='msgModal' ref={props.targetRef} data-show={props.showModal ? 'true' : 'false'}>
      <div
        className='msgModalBox'
        style={{
          maxWidth: `${props.maxWidth}`,
          maxHeight: `${props.maxHeight}`,
        }}
      >
        {props.children}
        <button className='msgModalCloser' onClick={closeMessage} />
      </div>
      <div className='msgModalOverlay' onClick={closeMessage} />
    </div>
  );
}

export default ModalComponent;
